export default {
  // Dialog title
  dialogTitle: "Common Counterparty",

  // Option titles
  commonInflowAbsolute: "Common Inflow (Absolute)",
  commonInflowRelative: "Common Inflow (Relative)",
  commonOutflowAbsolute: "Common Outflow (Absolute)",
  commonOutflowRelative: "Common Outflow (Relative)",

  // Option descriptions
  commonInflowAbsoluteInfo:
    "Selected nodes have absolute common inflow counterparties",
  commonInflowRelativeInfo:
    "Selected nodes have partial common inflow counterparties",
  commonOutflowAbsoluteInfo:
    "Selected nodes have absolute common outflow counterparties",
  commonOutflowRelativeInfo:
    "Selected nodes have partial common outflow counterparties",
};
